export default __webpack_public_path__ + "static/media/IC00002-disciple_icon.ffbd3aa2.svg";